import {Component, Input} from '@angular/core';
import {Router} from "@angular/router";
import {CourseRecap} from "../../../models/CourseRecap";

@Component({
  selector: 'app-course-card-recap',
  templateUrl: './course-card-recap.component.html',
  styleUrls: ['./course-card-recap.component.scss']
})
export class CourseCardRecapComponent {
  @Input() public Course:CourseRecap

  prix: number = 0;
  constructor(private router: Router) {
    this.Course = new CourseRecap();
  }

  ngOnInit() {
    let Reduction : number = parseInt(this.isNotNull(this.Course.Reduction));
    let Remboursement : number = parseInt(this.isNotNull(this.Course.Remboursement));
    let Acompte : number = parseInt(this.isNotNull(this.Course.Acompte));
    let Acompte2 : number = parseInt(this.isNotNull(this.Course.Acompte2));
    let Solde : number = parseInt(this.isNotNull(this.Course.Solde));

    if(this.Course.Periode === "Année"){
      this.prix = this.Course.PrixAnnee;
    }else {
      if (this.Course.Periode === "Année continuée") {
        this.prix = this.Course.PrixPremierSemestre + this.Course.PrixSecondSemestre;
      } else {
        this.prix = this.Course.PrixPremierSemestre;
      }
    }

    this.prix -= (Reduction - Remboursement + Acompte + Acompte2 + Solde);
  }

  isNotNull(param :any){
    if (param === null) return 0;
    if (param === "null") return 0;
    if (param === "NULL") return 0;
    return param;
  }

  /**
   * When stage card clicked, redirect to stage details
   */
  onStageClick() {
    setTimeout(() => this.router.navigate(['/cours/', this.Course.NumeroInstanceCours]), 500)
  }

  protected readonly CourseRecap = CourseRecap;
}
